import type { AxiosResponse } from 'axios';

interface GenerateProps {
  locationId?: string;
  serviceId?: string;
  preferredLang?: string;
  preferredStaff?: string;
  language?: string;
}

export const QrCode = (client) => ({
  generate({
    locationId,
    serviceId,
    preferredLang,
    preferredStaff,
    language,
  }: GenerateProps): Promise<AxiosResponse<unknown>> {
    const params: Record<string, string> = {};

    if (locationId) {
      params['location_id'] = locationId;
    }
    if (serviceId) {
      params['service_id'] = serviceId;
    }
    if (preferredLang) {
      params['preferred_lang'] = preferredLang;
    }
    if (preferredStaff) {
      params['preferred_staff'] = preferredStaff;
    }
    if (language) {
      params['language'] = language;
    }

    const query = Object.keys(params)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
      )
      .join('&');

    return client.get(`/api/v3/open/qr${query ? `?${query}` : ''}`);
  },
});
